/*
    © 2021 EcomGraduates.com
    https://www.ecomgraduates.com
*/

// Newsletter - Scroll to it after submit
if (window.location.href.indexOf('?customer_posted=true') > -1) {
    setTimeout(() => {
        document.querySelector('.newsletter-form').scrollIntoView()
    }, 750)
}

// Fix for product list items inside offcanvas mobile menu
document.querySelectorAll('#offcanvas-menu-upsell-collection .btn-atc').forEach(($btn) => {
    $btn.addEventListener('click', () => {
        const offcanvas = bootstrap.Offcanvas.getOrCreateInstance('#offcanvas-mobile-menu')
        offcanvas.hide()
    })
})

/*
    Navbar menu items open on hover (not click)
*/
document.querySelectorAll('#navbar .navbar-nav .nav-link.dropdown-toggle').forEach(($item) => {
    $item.addEventListener('mouseenter', () => {
        document.querySelectorAll('#navbar .navbar-nav .nav-link.dropdown-toggle').forEach(($item) => {
            $item.classList.remove('show')
            $item.setAttribute('aria-expaned', 'false')
            $item.nextElementSibling.classList.remove('show')
        })

        $item.classList.add('show')
        $item.setAttribute('aria-expaned', 'true')
        $item.nextElementSibling.classList.add('show')
        $item.nextElementSibling.setAttribute('data-bs-popper', 'none')
    })
    $item.addEventListener('mouseleave', () => {
        if (!$item.nextElementSibling.matches(':hover')) {
            $item.classList.remove('show')
            $item.setAttribute('aria-expaned', 'false')
            $item.nextElementSibling.classList.remove('show')
        }
    })

    $item.addEventListener('click', (e) => {
        window.location.href = $item.getAttribute('href')
    })
})
document.querySelector('#main').addEventListener('mouseenter', () => {
    document.querySelectorAll('#navbar .navbar-nav .nav-link.dropdown-toggle').forEach(($item) => {
        $item.classList.remove('show')
        $item.setAttribute('aria-expaned', 'false')
        $item.nextElementSibling.classList.remove('show')
    })
})

// Handle Plus/Minus in quantity steppers
window.qtyDecrease = (btn) => {
    const input = btn.closest('.quantity-wrapper').querySelector('input')
    const inputValue = Number(input.value)

    if (inputValue > 1) {
        input.value = inputValue - 1
    }
}
window.qtyIncrease = (btn) => {
    const input = btn.closest('.quantity-wrapper').querySelector('input')
    const inputValue = Number(input.value)

    input.value = inputValue + 1
}

// Recharge subscrptions page - Add back to account link
const rechargePageWrapper = document.querySelector('body#recharge-novum #recharge-te')

if (rechargePageWrapper) {
    rechargePageWrapper.insertAdjacentHTML('beforeend', `
        <p class="mt-7 text-center">
            <a href="/account" class="btn btn-outline-primary px-4 py-2">← Go back to account</a>
        </p>
    `)
}


/*
    Fix some pages that we can not accesss via code 
*/
if (window.location.href.includes('tools/recurring')) {
    document.querySelector('#main').classList.add('pt-16', 'pb-8')
}
function delete_cookie(name) {
  document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

function cartAttributeClear() {
    fetch('/cart/update.js', {
        method: "POST",
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/json;'
        },
        body: JSON.stringify({
            attributes: {
                eftid: '',
                notification_preferences: '',
            }
        })
    })
}

function checkURLParams() {
   const url = new URL(window.location.href);
    if (url.searchParams.has('trackClear')) {
      setTimeout(function(){
        cartAttributeClear()
        delete_cookie('ef_tid_c_a_4')
        delete_cookie('ef_tid_c_o_22')
        delete_cookie('transaction_id')
        console.log('data cleared')
        window.location.replace(window.location.pathname)
      }, 2000);
      
    } 
}
checkURLParams()